/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import type { ReactEventHandler } from 'react';

import { jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Anchor } from '@atlaskit/primitives/anchor';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/box';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { xcss } from '@atlaskit/primitives/xcss/xcss';

import { ThumbnailImage } from './thumbnail-image';

const thumbnailContainerStyles = xcss({
	gridArea: 'body',
});

const descriptionLinkStyles = xcss({
	display: 'inline-block',
});

interface SearchResultThumbnailProps {
	resultUrl: string;
	thumbnailUrl: string;
	onError?: ReactEventHandler<HTMLImageElement>;
}

export const SearchResultThumbnail = ({
	resultUrl,
	thumbnailUrl,
	onError,
}: SearchResultThumbnailProps): JSX.Element => (
	<Anchor xcss={[descriptionLinkStyles]} rel={'noreferrer'} target={'_blank'} href={resultUrl}>
		<Box testId="thumbnail-container" xcss={thumbnailContainerStyles}>
			{/* eslint-disable-next-line @atlassian/a11y/alt-text */}
			<ThumbnailImage src={thumbnailUrl} onError={onError} />
		</Box>
	</Anchor>
);
